import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import heroImage from '../assets/images/aboutHero.png';

import '../styles/Pages.css';

const RoadTunnels = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO SECTION */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>Road Tunnels</h1>
            <p>Highway Infrastructure Excellence</p>
          </div>
        </div>
      </section>

      {/* TEXT SECTION */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '40px', 
            textAlign: 'center' 
          }}>
            Highway Road Tunnel Projects
          </h2>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8', 
            marginBottom: '25px',
            textAlign: 'justify'
          }}>
            We are proud to announce that we have been awarded with Highway cum Road Tunnel in the State of Andhra Pradesh and we have since started the operations.
          </p>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8', 
            marginBottom: '25px',
            textAlign: 'justify'
          }}>
            This prestigious project showcases Max Infra's capability to execute complex road tunnel infrastructure in diverse geological conditions. Our expertise, combined with state-of-the-art equipment and experienced workforce, ensures safe and efficient execution of this critical highway infrastructure project.
          </p>

          <p style={{ 
            fontSize: '16px', 
            color: '#555', 
            lineHeight: '1.8',
            textAlign: 'justify'
          }}>
            The successful completion of this road tunnel project reaffirms our position as a leading infrastructure contractor in India, capable of delivering world-class solutions for challenging tunnel construction projects.
          </p>
        </div>
      </section>

      {/* ADDITIONAL INFO SECTION */}
      <section style={{ padding: '80px 20px', background: '#f9f9f9' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          
          <h2 style={{ 
            fontSize: '32px', 
            color: '#0066cc', 
            fontWeight: 'bold', 
            marginBottom: '40px', 
            textAlign: 'center' 
          }}>
            Our Capabilities
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' }}>
            
            {/* LEFT */}
            <div>
              <h3 style={{ fontSize: '20px', color: '#0066cc', fontWeight: 'bold', marginBottom: '15px' }}>
                Technical Excellence
              </h3>
              <p style={{ 
                fontSize: '16px', 
                color: '#555', 
                lineHeight: '1.8',
                textAlign: 'justify'
              }}>
                Max Infra brings decades of tunnelling expertise with advanced engineering techniques and modern machinery to handle complex road tunnel projects.
              </p>
            </div>

            {/* RIGHT */}
            <div>
              <h3 style={{ fontSize: '20px', color: '#0066cc', fontWeight: 'bold', marginBottom: '15px' }}>
                Quality & Safety
              </h3>
              <p style={{ 
                fontSize: '16px', 
                color: '#555', 
                lineHeight: '1.8',
                textAlign: 'justify'
              }}>
                We maintain the highest standards of quality and safety in all our operations, ensuring timely project completion with zero compromises.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RoadTunnels;